// Textos de Auditoría (guía 8.6) y la tabla de referentes (guía 1). Finales.

export const auditoriaPage = {
  explorer: {
    label: "Cielo de modelos",
    hint: "Arrastrá para girar. Cada punto es un modelo; cada nube, una familia.",
    find: "Encontrar el nuestro",
    back: "Volver a la vista general",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    regions: "Región",
    families: "Familia",
    all: "Todas",
    ours: "YvyrAI Nano · arquitectura propia",
    // Las cantidades por familia son las del re-chequeo; se aclara al mostrarlas.
    countNote: "modelos en el re-chequeo de 10.808",
    description:
      "Escena: unos 25.700 puntos de luz agrupados por familia de arquitectura, con la proporción medida en la auditoría. La familia más grande, Llama, forma una galaxia; las demás, cúmulos más chicos; los modelos sin familia declarada, polvo disperso. Un único punto, lejos de todos, es YvyrAI Nano.",
  },
  numbers: { totalLabel: "en total" },
  how: {
    title: "Cómo lo hicimos",
    steps: [
      {
        title: "Recorrimos el índice de etiquetas de Hugging Face",
        body: "por país, región e idioma. La búsqueda por palabras no sirve para probar que algo no existe: ni siquiera encontraba nuestro propio modelo.",
      },
      { title: "Usamos nuestro modelo como control.", body: "Si una búsqueda no lo encontraba, la búsqueda estaba mal." },
      { title: "Agrupamos cada modelo por la familia de arquitectura que declara.", body: "" },
      { title: "Revisamos a mano", body: "los que no declaraban familia y los modelos de referencia de cada país." },
    ],
  },
  found: {
    title: "No encontramos otro modelo de lenguaje de la región con arquitectura propia.",
    respect:
      "Varios de estos modelos son mucho más capaces que el nuestro. Lo que mide esta auditoría es otra cosa: de dónde viene el diseño.",
    table: { caption: "Modelos de referencia revisados y la familia de la que parten", model: "Modelo", family: "Parte de", note: "Nota" },
    // 🔵 La guía da el país solo de algunos referentes: se muestra donde está dicho.
    refs: [
      { model: "ALIA y Salamandra", family: "Llama", note: "España" },
      { model: "Águila", family: "Falcon", note: "" },
      { model: "FLOR", family: "BLOOM", note: "" },
      { model: "RigoChat", family: "Qwen2", note: "" },
      { model: "BERTIN", family: "GPT-J", note: "" },
      { model: "Latxa", family: "Llama", note: "" },
      { model: "Lince", family: "Falcon", note: "" },
      { model: "Tucano", family: "Arquitectura Llama 2", note: "Brasil · entrenado desde cero" },
      { model: "Latam-GPT", family: "Llama 3.1 70B", note: "" },
      { model: "maracatu-80m", family: "Llama", note: "Brasil · entrenado desde cero, de tamaño parecido al nuestro" },
    ],
  },
  recheck: {
    title: "Lo volvimos a correr",
    body: "El 1 de octubre de 2026 repetimos la búsqueda sobre 10.808 modelos. El resultado no cambió. En todo Hugging Face, la etiqueta «paraguay» tiene un solo modelo: el nuestro.",
  },
  limits: {
    title: "Por qué decimos «hasta donde pudimos verificar».",
    body: "Probar que algo no existe nunca es definitivo. Un modelo privado, sin etiquetas o publicado solo en un paper puede habernos quedado afuera. Por eso el resguardo va siempre con el claim, y va a seguir yendo.",
  },
  close: { body: "¿Conocés uno que se nos pasó? Escribinos y actualizamos esta página.", cta: "Escribinos" },
} as const;
